import React, { ReactNode, useEffect } from 'react';
import { IAccessControlCheckProps } from './IAccessControlCheckProps';
import { useAccessControlCheck } from './hooks/useAccessControlCheck';

interface IAccessControlCheckComponentProps extends IAccessControlCheckProps {
  children: ReactNode;
  showOnFailure?: ReactNode;
  actionOnFailure?: () => void;
}

export const AccessControlCheck: React.FC<IAccessControlCheckComponentProps> = ({
  children,
  showOnFailure,
  actionOnFailure,
  ...accessControlCheckProps
}) => {
  const showChildren = useAccessControlCheck([accessControlCheckProps])[0];

  useEffect(() => {
    if (!showChildren) {
      actionOnFailure?.();
    }
  }, [showChildren, actionOnFailure]);

  return <>{showChildren ? children : showOnFailure}</>;
};
